import type { FaireProductEntity } from "../../entity_types/product";

export const p_syad9f54tk: FaireProductEntity = {
  token: "p_syad9f54tk",
  type: "product",
  name: "Peppermints Tissue Paper",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/3cd3fd93c8a9ac930a19142bcb036143a971e03abd806e91218d1eece3e3e923.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6a7c0c1d1d2e386ddfaf9a3a4faf4770f68e9bd89a7c1585a5303a8656d71cfb.jpeg",
  ],
  priceDollars: 4,
  description:
    "10 sheets of tissue paper per package. Made from 100% recycled paper and it's 100% recyclable. Mix and match with our coordinating gift bags (sold separately). Yay for plastic packaging! 20 Inch x 30 Inch sheets. 10 sheets per package",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:54.739Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
